import { useEffect, useState } from "react";
import { useLocation, Link as RouterLink } from "react-router";
import { useAppSelector, useAppDispatch } from "../../redux/store";

import { Box, Typography, Alert, Link, Grid, Fade } from "@mui/material";

import BrandCarousel from "../login/components/BrandCarousel";
import { confirmEmail } from "../../redux/slices/loginSlice";

const ConfirmEmail = () => {
  const [fadeIn, setFadeIn] = useState(false);
  const { loading, confirmEmailSuccess, confirmEmailError } = useAppSelector(
    (state) => state.login,
  );
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setFadeIn(true);

    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const email = searchParams.get("email");
      const token = searchParams.get("token");

      if (email && token) {
        dispatch(confirmEmail({ email, token }));
      }
    }
  }, [location, dispatch]);

  return (
    <Fade in={fadeIn}>
      <Grid
        sx={{ width: "100vw", height: "100vh", overflow: "auto" }}
        container
      >
        <Grid
          size={{ sm: 12, md: 6 }}
          sx={{ display: "flex", alignItems: "center", p: 2 }}
        >
          <Box
            sx={{
              maxWidth: 350,
              mx: "auto",
              textAlign: "center",
              "& .MuiOutlinedInput-input": {
                p: "4.5px 14px",
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: 0,
              },
              "& .MuiTextField-root": {
                mt: 0,
              },
              "& .MuiButton-root": {
                borderRadius: 0,
                p: "2.75px 15px",
              },
            }}
          >
            <BrandCarousel />
            <Typography variant="h4" sx={{ fontSize: 24 }} gutterBottom>
              Email Confirmation
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: 15, mb: 2 }}
              gutterBottom
            >
              We're verifying your account
            </Typography>

            {loading ? (
              <Alert severity="info" sx={{ mt: 2, textAlign: "left" }}>
                We are verifying your account. Please wait a moment.
              </Alert>
            ) : null}
            {confirmEmailSuccess ? (
              <Alert severity="success" sx={{ mt: 2, textAlign: "left" }}>
                Account is verified.{" "}
                <Link
                  component={RouterLink}
                  to="/login"
                  style={{ textDecoration: "none" }}
                >
                  Back to login
                </Link>
              </Alert>
            ) : null}
            {confirmEmailError ? (
              <Alert severity="error" sx={{ mt: 2, textAlign: "left" }}>
                {confirmEmailError}{" "}
                <Link
                  component={RouterLink}
                  to="/login"
                  style={{ textDecoration: "none" }}
                >
                  Back to login
                </Link>
              </Alert>
            ) : null}
          </Box>
        </Grid>
        <Grid
          size={{ sm: 12, md: 6 }}
          sx={{
            display: { xs: "none", md: "block" },
            height: "100vh",
            overflow: "hidden",
            borderRadius: 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{
                height: "100vh",
                width: "100%",
                objectFit: "cover",
                objectPosition: "center",
                display: "block",
              }}
              src="/login_img.jpg"
              alt="Background"
            />
          </Box>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default ConfirmEmail;
